/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
import React, { Fragment, useState } from 'react';

import { useContextCurrentSite } from 'contexts';
import LoadingPlaceholder from 'components/loadingPlaceholder';
import usePlacesProvider from 'dataProvider/hooks/usePlacesProvider';

import { useContextMatchParams } from 'contexts/matchParams';
import { useContextProperties } from 'contexts/properties';
import { useContextResultOrigin } from 'contexts/resultOrigin';
import useGetPlace from 'dataProvider/hooks/useGetPlace';

import { AtresPieChart, PactometroCheckSimple } from 'components';
import BreadCrumb from 'components/breadcrumb';
import { useNearestTown } from '../../dataProvider';
import { TYPES, SUBTYPES } from '../../envs';
import AtresBarChart from '../../components/charts/atresBarChart';
import TableCompare from '../../components/table';
import Tag from '../../components/tag';
import Tags from '../../components/tags';
import ElTabs from '../../components/elTabs';
import Autocomplete from '../../components/autocomplete';
import TableScrutine from '../../components/tableScrutiny';

import { getSite, LOCALHOST } from '../../constants/sites';

import { excludedGrandParentIds } from '../../core/constants';

const Town = ({
  dataResult,
  oldData,
  onChangeLocation,
  provincePlace,
  selectedPlace
}) => {
  const { matchParams } = useContextMatchParams();
  const {
    chartType,
    community,
    electionNumber,
    town,
    province,
    type,
    subtype,
    year
  } = matchParams;

  const { params } = useContextProperties();
  const resultOrigin = useContextResultOrigin();

  const [autocomplePro, setAutocomplePro] = useState('');
  const [autocompleCom, setAutocompleCom] = useState('');
  const [autocompleMun, setAutocompleMun] = useState('');

  const Chart = chartType === 'arc' ? AtresPieChart : AtresBarChart;
  const site = getSite();
  const { currentSite } = useContextCurrentSite();

  const { rows } =
    params.sites[site === LOCALHOST ? currentSite : site].views[
      type.toLocaleLowerCase()
    ].detail;

  const totalVotes = Number(dataResult.totalVotes);
  const currentCountPercent = Number(dataResult.currentCountPercent);
  const abstentionVotes = Number(dataResult.abstentionVotes);
  const abstentionPercent = Number(dataResult.abstentionPercent);
  const whiteVotes = Number(dataResult.whiteVotes);
  const whitePercent = Number(dataResult.whitePercent);
  const invalidVotes = Number(dataResult.invalidVotes);
  const invalidPercent = Number(dataResult.invalidPercent);

  const { result: dataPlacesTown } = usePlacesProvider({
    type: 'TOWN',
    sortby: 'name',
    parentId: province,
    name: autocompleMun,
    grandParentId: province ? null : community,
    electionType: type
  });

  const { data: nearestTownData } = useNearestTown({
    townId: selectedPlace?.ineId,
    latitude: selectedPlace?.location.lat,
    longitude: selectedPlace?.location.lon,
    electionType: type,
    community
  });

  const { result: dataPlacesProvince } = usePlacesProvider({
    type: 'PROVINCE',
    sortby: 'name',
    parentId: type === TYPES.REGIONAL ? community : null,
    electionType: type
  });
  const { result: dataPlacesRegion } = usePlacesProvider({
    type: 'REGION',
    sortby: 'name',
    excludedGrandParentIds,
    electionType: type
  });

  const selectedCommunity = useGetPlace(provincePlace?.parentId, type);

  const dataBreadcrumb = [
    // {
    //   name: type === TYPES.REGIONAL ? 'Autonómicas' : 'Municipales',
    //   ineId: 'C108',
    //   typePlace: 'COUNTRY'
    // },
    selectedCommunity,
    provincePlace,
    selectedPlace
  ];
  if (
    !rows ||
    !provincePlace ||
    !dataPlacesTown ||
    !dataPlacesProvince ||
    !dataPlacesRegion
  ) {
    return <LoadingPlaceholder />;
  }

  const content = rows.map((row, index) => (
    <div className={row.class} key={`row-${index}`}>
      {row.columns.map((column, index2) => (
        <div className={column.class} key={`col-${index2}`}>
          {column.components.map(item => (
            <div className={item.class || ''} key={item.module}>
              {item.module === 'DETAILS_SELECTORS' && (
                <Fragment>
                  <div className="row-places">
                    {/* PlacesProvider REGION */}
                    {dataPlacesRegion && type === TYPES.REGIONAL && (
                      <div className="col-places col-places--region">
                        <Autocomplete
                          results={dataPlacesRegion.filter(d =>
                            autocompleCom
                              ? d.name
                                  .toLocaleLowerCase()
                                  .includes(autocompleCom.toLocaleLowerCase())
                              : d
                          )}
                          onChange={value => setAutocompleCom(value)}
                          onSelect={(e, select) => {
                            onChangeLocation(e, select);

                            setAutocompleCom('');
                          }}
                          placeholder="Buscar comunidad"
                          showArrow
                          defaultValue={community}
                          type={type}
                          params={params}
                        />
                      </div>
                    )}

                    {/* PlacesProvider PROVINCE */}
                    {dataPlacesRegion && dataPlacesProvince && (
                      <div className="col-places col-places--province">
                        <Autocomplete
                          results={[
                            ...dataPlacesRegion.map(d => ({
                              ...d
                            })),
                            ...dataPlacesProvince.filter(d =>
                              autocomplePro
                                ? d.name
                                    .toLocaleLowerCase()
                                    .includes(autocomplePro.toLocaleLowerCase())
                                : d
                            )
                          ]}
                          onChange={value => setAutocomplePro(value)}
                          onSelect={(e, select) => {
                            onChangeLocation(e, select);
                          }}
                          placeholder="Buscar provincia"
                          showArrow
                          defaultValue={province}
                          type={type}
                          params={params}
                          province={province}
                        />
                      </div>
                    )}
                    {dataPlacesRegion && dataPlacesTown && (
                      <div className="col-places col-places--town">
                        <Autocomplete
                          results={[
                            ...dataPlacesRegion.map(d => ({
                              ...d
                            })),
                            ...dataPlacesTown
                          ]}
                          onChange={value => setAutocompleMun(value)}
                          onSelect={(e, select) => {
                            setAutocompleMun('');
                            onChangeLocation(e, select);
                            setAutocompleMun('');
                          }}
                          placeholder="Buscar municipio"
                          showArrow
                          notShowValue
                          type={type}
                          params={params}
                          defaultValue={selectedPlace.ineId}
                        />
                      </div>
                    )}
                  </div>
                  <BreadCrumb
                    dataBreadcrumb={dataBreadcrumb}
                    onClick={onChangeLocation}
                  />
                </Fragment>
              )}
              {item.module === 'SEAT_DETAILS' && (
                <Fragment>
                  <table className="infoTable">
                    <tbody>
                      <tr>
                        <td className="key">Votos contabilizados: </td>
                        <td className="value votes">
                          {Number.isNaN(totalVotes)
                            ? 'Cargando...'
                            : totalVotes.toLocaleString('de')}
                        </td>
                        <td className="value votes_percent">
                          {Number.isNaN(currentCountPercent)
                            ? 'Cargando...'
                            : `${currentCountPercent.toLocaleString('de')}%`}
                        </td>
                      </tr>
                      <tr>
                        <td className="key">Abstenciones: </td>
                        <td className="value votes">
                          {Number.isNaN(abstentionVotes)
                            ? 'Cargando...'
                            : abstentionVotes.toLocaleString('de')}
                        </td>
                        <td className="value abstention_percent">
                          {Number.isNaN(abstentionPercent)
                            ? 'Cargando...'
                            : `${abstentionPercent.toLocaleString('de')}%`}
                        </td>
                      </tr>
                      <tr>
                        <td className="key">Votos en blanco: </td>
                        <td className="value whites">
                          {Number.isNaN(whiteVotes)
                            ? 'Cargando...'
                            : whiteVotes.toLocaleString('de')}
                        </td>
                        <td className="value whites_percent">
                          {Number.isNaN(whitePercent)
                            ? 'Cargando...'
                            : `${whitePercent.toLocaleString('de')}%`}
                        </td>
                      </tr>
                      <tr>
                        <td className="key">Votos nulos: </td>
                        <td className="value null">
                          {Number.isNaN(invalidVotes)
                            ? 'Cargando...'
                            : invalidVotes.toLocaleString('de')}
                        </td>
                        <td className="value null_percent">
                          {Number.isNaN(invalidPercent)
                            ? 'Cargando...'
                            : `${invalidPercent.toLocaleString('de')}%`}
                        </td>
                      </tr>
                      {dataResult.totalSeats > 0 && (
                        <tr>
                          <td className="key">Total de escaños: </td>
                          <td className="value votes">
                            {Number(dataResult.totalSeats).toLocaleString('de')}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </Fragment>
              )}
              {item.module === 'BACK' && (
                <p className="buttonBackContainer">
                  <a
                    href={provincePlace.path}
                    type="button"
                    target="_parent"
                    className="tag button current"
                    onClick={event => {
                      onChangeLocation(event, provincePlace);
                    }}
                    rel="noreferrer"
                  >
                    Volver
                  </a>
                </p>
              )}
              {item.module === 'RESULTADOS' && (
                <div className="detail-bar-chart">
                  <AtresBarChart
                    data={dataResult.partiesResult || []}
                    dataKey="votesPercent"
                    isSenate={subtype === SUBTYPES.SENATE}
                    showMajorityLine={
                      type === TYPES.REGIONAL
                        ? !province
                        : !province && !community
                    }
                    slice={8}
                    showLabel
                    unitLabel="votos"
                    labelAbrv="%"
                    seatTotal={dataResult.totalVotes || 0}
                  />
                </div>
              )}
              {item.module === 'RESULTADOS_DOBLES' && (
                <div>
                  <Chart
                    chartInfo1={{
                      innerRadius: 122,
                      outerRadius: 165,
                      label: year
                    }}
                    chartInfo2={{
                      innerRadius: 90,
                      outerRadius: 120,
                      label: resultOrigin.historic.year
                    }}
                    data={dataResult.partiesResult || []}
                    data2={oldData.partiesResult || []}
                    isSenate={subtype === SUBTYPES.SENATE}
                    showMajorityLine
                    dataKey="votesPercent"
                    unitLabel={null}
                    labelAbrv=""
                    seatTotal={dataResult.totalVotes || 0}
                    type={type}
                  />
                </div>
              )}
              {item.module === 'TABS_CONTAINER' && (
                <ElTabs
                  titles={item.data.tabs.map(tab =>
                    tab.title === 'PREV_YEAR'
                      ? oldData.year?.toString()
                      : tab.title
                  )}
                >
                  {item.data.tabs.map(tab => (
                    <Fragment key={tab.component}>
                      {tab.component === 'TABLE' && (
                        <TableCompare
                          className="current"
                          data={dataResult}
                          oldData={oldData && oldData}
                          electionNumber={electionNumber}
                          electionType={type}
                          placeId={town}
                          year={year}
                          details={
                            subtype === SUBTYPES.CONGRESS ||
                            type === TYPES.REGIONAL ||
                            type === TYPES.MUNICIPAL
                          }
                          isSenate={subtype === SUBTYPES.SENATE}
                          hideSeats
                          type={type}
                        />
                      )}
                      {tab.component === 'RESULTADOS_PREVIOS' && (
                        <div>
                          <div className="detail-bar-chart">
                            {/* <Chart */}
                            <AtresBarChart
                              data={oldData.partiesResult || []}
                              slice={8}
                              dataKey="votesPercent"
                              isSenate={subtype === SUBTYPES.SENATE}
                              showMajorityLine={
                                type !== TYPES.REGIONAL
                                  ? !province && !community
                                  : !province
                              }
                              showLabel
                              labelAbrv="%"
                              seatTotal={dataResult.totalSeats || 0}
                              unitLabel={null}
                              type={type}
                            />
                          </div>
                        </div>
                      )}
                      {tab.component === 'PACTOS' && (
                        <div className="pactometroWrapper">
                          <div className="pactometroScroll">
                            <PactometroCheckSimple
                              totalSeat={dataResult.totalSeats}
                              seatData={dataResult.partiesResult || []}
                              type={type}
                            />
                          </div>
                        </div>
                      )}
                    </Fragment>
                  ))}
                </ElTabs>
              )}
              {item.module === 'TABLE_SCRUTINE' && (
                <TableScrutine
                  totalVotes={dataResult?.totalVotes?.toLocaleString('de-DE')}
                  invalidVotes={dataResult?.invalidVotes?.toLocaleString(
                    'de-DE'
                  )}
                  whiteVotes={dataResult?.whiteVotes?.toLocaleString('de-DE')}
                  abstentionVotes={dataResult?.abstentionVotes?.toLocaleString(
                    'de-DE'
                  )}
                  invalidPercent={dataResult?.invalidPercent}
                  whitePercent={dataResult?.whitePercent}
                  abstentionPercent={dataResult?.abstentionPercent}
                  participationPercent={dataResult?.participationPercent}
                  currentCountPercent={dataResult?.currentCountPercent}
                  isActive={resultOrigin?.primary?.active}
                  difference={
                    Number(dataResult.participationPercent) -
                    Number(oldData.participationPercent)
                  }
                />
              )}
              {item.module === 'TAGS' && (
                <Fragment>
                  <h3 className="tags-title">
                    Resultado de las elecciones en:
                  </h3>
                  <div className="tags_container">
                    <Tags>
                      {nearestTownData?.map(d => {
                        if (!d.name) {
                          return null;
                        }
                        return (
                          <Tag
                            key={`${d.ineId}-${d.name}`}
                            onClick={event => {
                              onChangeLocation(event, d);
                            }}
                            native
                            route={d.path}
                          >
                            {d.name}
                          </Tag>
                        );
                      })}
                    </Tags>
                  </div>
                </Fragment>
              )}
            </div>
          ))}
        </div>
      ))}
    </div>
  ));
  return (
    <Fragment>
      <div className="page-detail">{content}</div>
    </Fragment>
  );
};

export default Town;
